import React from "react";
import styled from "styled-components";

const DescriptionWrapper = styled.div`
	p {
		font-size: 1em;
	}
`;

const ContactList = ({ staffContact }) => (
	<div className="row">
		{staffContact.map(contact => (
			<div key={contact.id} className="p-3 col-xl-4 w-100">
				<div className="card px-0">
					<div className="card-header bg-dark text-light">
						<h4
							id={`contact-${contact.id}`}
							className="m-0 card-title text-center"
						>
							{contact.name}
							<div className="h6">{contact.title}</div>
						</h4>
					</div>
					{contact.description ? (
						<DescriptionWrapper className="p-2 p-lg-4 p-xl-2 border-bottom">
							{contact.description}
						</DescriptionWrapper>
					) : null}
					<ul className="list-group-flush p-0 m-0">
						{contact.phone ? (
							<li className="list-group-item">
								Phone:{" "}
								<a href={`tel:${contact.phone}`}>
									{contact.phone}
								</a>
							</li>
						) : null}
						{contact.email ? (
							<li className="list-group-item rounded-bottom">
								Email:{" "}
								<a href={`mailto:${contact.email}`}>
									{contact.email}
								</a>
							</li>
						) : null}
					</ul>
				</div>
			</div>
		))}
	</div>
);

export default ContactList;
